(function () {
    'use strict';
    angular.module('Directives').directive('bbaFinancialDetails', bbaFinancialDetails);
    bbaFinancialDetails.$inject = ['$filter'];

    function bbaFinancialDetails($filter) {
        return {
            restrict: 'E',
            templateUrl: '/templates/directives/components/job-details/bbaFinancialDetails.html',
            scope: {
                header: '=',
                data: '=',
                timeBasedData: '=',
                isHideRatesEngine: '=?'
            },
            link: bbaFinancialDetailsLink
        }

        function bbaFinancialDetailsLink($scope, elements, attrs) {

        }
    }
})();



// WEBPACK FOOTER //
// ./js/directives/component/job-details/bbaFinancialDetails.js